
import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, CommonGlobalService, UUID, CallbackErrorAxios, CallbackWarningAxios } from '@umanforge/common';
import { SectorSettings, Setting, SettingDB } from 'interfaces/setting.interface';
import { API } from 'constants/api.contants';
import { DEFAULT_VALUES } from 'constants/calendar.constants';


export class SettingService {

  static getSectorSettingsBySector(
    sectorId: UUID,
    token: string | null, dispatch: Dispatch
  ) : Promise<SectorSettings> {
    return new Promise( async resolve => {
      await this.getSettingBySector( sectorId, token, dispatch ).then( ( response: SettingDB[] ) => {
        const sectorSetting: SectorSettings = {
          idSector: sectorId
        };

        // place the setting at the right attribut of SectorSetting and replace value by a number or a default value if null
        // TODO move some part of this in the back end
        for ( const setting of response ) {
          switch ( setting.name ) {
          case 'max_file_size_mo':            sectorSetting.maxFileSizeMo           = { ...setting, value: parseInt( setting.value ?? `${ DEFAULT_VALUES.MAX_FILE_SIZE}` ) };  break;
          case 'number_month_delete_image':   sectorSetting.numberMonthDeleteImage  = { ...setting, value: parseInt( setting.value ?? `${ DEFAULT_VALUES.NUMBER_MONTH_DELETE_IMAGE}` ) };  break;
          case 'calendar_step':               sectorSetting.calendarStep            = { ...setting, value: parseInt( setting.value ?? `${ DEFAULT_VALUES.STEP}` ) };  break;
          case 'calendar_start_hour':         sectorSetting.calendarStartHour       = { ...setting, value: parseInt( setting.value ?? `${ DEFAULT_VALUES.HOURSTART}` ) };  break;
          case 'calendar_end_hour':           sectorSetting.calendarEndHour         = { ...setting, value: parseInt( setting.value ?? `${ DEFAULT_VALUES.HOUREND}` ) };  break;
          case 'show_weekend':                sectorSetting.showWeekend             = { ...setting, value: parseInt( setting.value ?? `${ DEFAULT_VALUES.SHOWWEEKEND}` ) };  break;
          case 'number_minute_close_action':  sectorSetting.numberMinuteCloseAction = { ...setting, value: parseInt( setting.value ?? `${ DEFAULT_VALUES.NUMBER_MINUTE_CLOSE_ACTION}` ) };  break;
          case 'number_day_show':             sectorSetting.numberDayShow           = { ...setting, value: parseInt( setting.value ?? `${ DEFAULT_VALUES.NUMBER_DAYS_SHOW}` ) };  break;
          default: break;
          }
        }
        resolve( sectorSetting );
      } );
    } );
  }

  static getSettingById(
    settingId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<Setting> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.SETTING}/${settingId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<Setting> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static getSettingBySector(
    sectorId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<SettingDB[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.SETTING_BY_SECTOR}/${sectorId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<SettingDB[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data.map( setting => { return { ...setting }; } ) );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static putSetting(
    settingId: string,
    setting: Setting,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ) {
    return new Promise( async resolve => {
      AXIOS.put( `${API.SETTING}/${settingId}`, { value: `${setting.value}` }, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }
};